import { useDispatch, useSelector } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import {
    selectIsDataCreditsModalOpen,
    setDataCreditsModalOpen,
} from "app/pages/sales-intelligence/modules/quota/store";

import { AcknowledgeModal } from "../../../../common-components/AcknowledgeModal/AcknowledgeModal";

export const DataCreditsModal = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(selectIsDataCreditsModalOpen);

    const handleConfirm = () => {
        dispatch(setDataCreditsModalOpen(false));
    };

    return (
        <AcknowledgeModal
            isOpen={isOpen}
            onConfirm={handleConfirm}
            title={translate("si.quota.low-credits.banner.no_touch.title")}
            description={translate("si.quota.low-credits.banner.no_touch.description")}
        />
    );
};
